import { CloudAnomalyAlert } from "../../types/alert";
import { Card, CardContent, CardHeader, CardTitle } from "../../../../ui/common-ui/card";
import { AlertTriangle, Users } from "lucide-react";

interface AlertStatsProps {
  alerts: CloudAnomalyAlert[];
}

export const AlertStats = ({ alerts }: AlertStatsProps) => {
  const uniqueResources = new Set<string>();
  alerts.forEach(alert => {
    if (alert.attackPath) {
      Object.values(alert.attackPath).forEach((step: any) => {
        if (step?.resource) uniqueResources.add(step.resource);
      });
    }
    if (alert.affectedResources) {
      alert.affectedResources.forEach((res: string) => uniqueResources.add(res));
    }
  });

  const stats = {
    total: alerts.length,
    critical: alerts.filter(a => a.severity?.toLowerCase() === "critical").length,
    high: alerts.filter(a => a.severity?.toLowerCase() === "high").length,
    medium: alerts.filter(a => a.severity?.toLowerCase() === "medium").length,
    uniqueResources: uniqueResources.size,
  };

  const statCards = [
    {
      title: "Total Alerts",
      value: stats.total,
      icon: AlertTriangle,
      className: "text-primary",
    },
    {
      title: "Critical",
      value: stats.critical,
      icon: AlertTriangle,
      className: "text-red-500",
    },
    {
      title: "High",
      value: stats.high,
      icon: AlertTriangle,
      className: "text-orange-500",
    },
    {
      title: "Medium",
      value: stats.medium,
      icon: AlertTriangle,
      className: "text-yellow-500",
    },
    {
      title: "Affected Resources",
      value: stats.uniqueResources,
      icon: Users,
      className: "text-blue-500",
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4">
      {statCards.map((stat) => {
        const Icon = stat.icon;
        return (
          <Card key={stat.title} className="rounded-2xl bg-card portal-card-elevated portal-card-hover">
            <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
              <CardTitle className="text-sm font-medium text-muted-foreground">
                {stat.title}
              </CardTitle>
              <Icon className={`h-4 w-4 ${stat.className}`} />
            </CardHeader>
            <CardContent>
              <div className={`text-2xl font-bold ${stat.className}`}>
                {stat.value}
              </div>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
};
